export const serializeManagerStatus = status => ({
  description: status.description,
  color: status.color || '#383c3f',
  title: status.name,
  disabled: !status.active,
  value: Number(status.id),
});

export const serializeManagerStatuses = statuses => {
  if (!statuses || statuses.length === 0) {
    return [];
  }

  return statuses.map(serializeManagerStatus);
};
